import React, { useEffect, useState } from 'react'
import { ActiveTarget } from './AutomationConstructor'
import { Controller, useForm } from 'react-hook-form';
import { Button, DialogTitle, DialogContent, DialogContentText, Dialog, MenuItem, Select, TextField, Autocomplete, Checkbox, Switch, IconButton } from '@mui/material';
import _ from 'lodash';
import { FaTrash } from 'react-icons/fa';


const CONDITION_TYPES = [
    {
        label: "Назначенные теги",
        value: "TAG",
        schema: {
            fields: [
                {
                    key: "tags",
                    label: "Теги",
                    type: "string[]",
                },
                {
                    key: "operator",
                    label: "Оператор",
                    type: "string",
                },
            ],
        },
    },
    {
        label: "Подписка",
        value: "SUBSCRIPTION",
        schema: {
            fields: [
                {
                    key: "subscription",
                    label: "Подписка",
                    type: "boolean",
                },
            ],
        },
    },
    {
        label: "Переменная",
        value: "VARIABLE",
        schema: {
            fields: [
                {
                    key: "variable",
                    label: "Переменная",
                    type: "string",
                },
                {
                    key: "operator",
                    label: "Оператор",
                    type: "string",
                },
                {
                    key: "value",
                    label: "Значение",
                    type: "string",
                },
            ],
        },
    },
]


interface ConditionEditFormProps {
    target: ActiveTarget | null;
    onSave: (branch: any) => void;
}
export const ConditionEditForm = ({ target, onSave }: ConditionEditFormProps) => {
    console.log("ConditionEditForm.target", target);

    const [openDialog, setOpenDialog] = useState(false);
    // Branch form
    const { register, handleSubmit, watch, control, setValue, getValues } = useForm({
        defaultValues: _.get(target, `entity.data.payload.branches.${target?.payload?.branchIndex}`) || {
            operator: "AND",
            conditions: [],
        },
        mode: "onChange",
    });

    const onSubmit = (branchInput: any) => {
        console.log("branchInput", branchInput);
        onSave(branchInput);
    };

    useEffect(() => {
        return () => {
            console.log("ConditionEditForm.unmount");
            onSave(getValues());
        }
    }, []);

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
                <Controller
                    control={control}
                    name="operator"
                    render={({ field }) => (
                        <Select label="Оператор" {...field} fullWidth>
                            <MenuItem value="AND">AND</MenuItem>
                            <MenuItem value="OR">OR</MenuItem>
                        </Select>
                    )}
                />
                {watch("conditions")?.length > 0 && watch("conditions")?.map((condition: any, index: number) => (
                    <div key={index}>
                        <div className='text-lg font-bold flex justify-between items-center mb-2'>
                            <div>
                                {condition.conditionType}
                            </div>
                            {/* Remove condition button */}
                            <IconButton type="button" onClick={() => {
                                const prevValues = getValues("conditions") || []
                                setValue("conditions", prevValues.filter((_: any, i: number) => i !== index))
                            }}>
                                <FaTrash size={16} />
                            </IconButton>
                        </div>
                        <div>
                            {condition.conditionType === "TAG" && (
                                <div>
                                    <Controller
                                        control={control}
                                        name={`conditions.${index}.value`}
                                        defaultValue={[]}
                                        render={({ field: f }) => (
                                            <Autocomplete
                                                value={f.value || []}
                                                onChange={(_, value) => f.onChange(value)}
                                                multiple
                                                freeSolo
                                                options={[]} // Можно оставить пустым, если подсказки не нужны
                                                renderInput={(params) => (
                                                    <TextField {...params} id="tags" label="Теги" />
                                                )}
                                            />
                                        )}
                                    />
                                </div>
                            )}
                            {condition.conditionType === "SUBSCRIPTION" && (
                                <div>
                                    <Controller
                                        control={control}
                                        name={`conditions.${index}.value`}
                                        defaultValue={condition.value}
                                        render={({ field }) => (
                                            <Switch {...field} disabled={true} />
                                        )}
                                    />
                                </div>
                            )}
                            {condition.conditionType === "VARIABLE" && (
                                <div>
                                    <TextField label="Переменная" fullWidth {...register(`conditions.${index}.value`)} />
                                    <TextField label="Оператор" fullWidth {...register(`conditions.${index}.operator`)} />
                                    <TextField label="Значение" fullWidth {...register(`conditions.${index}.value`)} />
                                </div>
                            )}
                        </div>
                    </div>
                ))}

                {/* Добавить условие */}
                <Button variant="contained" type="button" fullWidth onClick={() => setOpenDialog(true)}>Добавить условие</Button>

                {/* Dialog */}
                <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                    <DialogTitle>Добавить условие</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Выберите тип условия</DialogContentText>
                        <Select label="Тип условия" fullWidth onChange={(e) => {
                            const type = CONDITION_TYPES.find((type) => type.value === e.target.value);
                            if (type) {
                                const prevValues = getValues("conditions") || []

                                const variable = type.schema.fields[0].key
                                const operator = type.schema.fields[1].key

                                let defaultValue: any = ""
                                if (type.schema.fields[0].type === "string[]") {
                                    defaultValue = []
                                } else if (type.schema.fields[0].type === "boolean") {
                                    defaultValue = true
                                } else {
                                    defaultValue = ""
                                }

                                setValue("conditions", [...prevValues, {
                                    variable: variable,
                                    operator: operator,
                                    value: defaultValue,
                                    conditionType: type.value,
                                }]);
                            }

                            setOpenDialog(false)
                        }}>
                            {CONDITION_TYPES.map((type) => (
                                <MenuItem key={type.value} value={type.value}>
                                    {type.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </DialogContent>
                </Dialog>
                {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            </form>
        </div>
    )
}
